import styled from "styled-components";
import ActivitiesLeftBg from "../../../../assets/images/manage-participant/activities-left-bg.svg";
import ActivitiesRightBg from "../../../../assets/images/manage-participant/activities-right-bg.svg";
import AssessmentRightBg from "../../../../assets/images/manage-participant/assessment-right-bg.svg";
import AssessmentLeftBg from "../../../../assets/images/manage-participant/assessments-left-bg.svg";
import EventsLeftBg from "../../../../assets/images/manage-participant/events-left-bg.svg";
import EventsRightBg from "../../../../assets/images/manage-participant/events-right-bg.svg";
import { textFieldTypographyH5SemiBold } from "../../../../components/typography/MuiTypography.style";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ManageParticipantsInfoStyle = styled.div`
  background: ${COLORS.cirrus_white};
  .bg {
    background: linear-gradient(
      180deg,
      ${COLORS.primary_dark_blue9} 0%,
      ${COLORS.primary_light_blue6} 136.67%
    );
    height: 92px;
    border-radius: 8px 8px 0px 0px;
    position: relative;
    .participant-avatar-container {
      position: absolute;
      top: 25px;
      padding-left: 24px;
      .participant-avatar {
        border-radius: 50%;
        border: 8px solid ${COLORS.cirrus_white};
      }
      .participant-avatar-status {
        position: absolute;
        top: 100px;
        left: 40px;
      }
    }
  }
  .align-center {
    align-self: center;
  }

  .participant-container {
    margin-top: 75px;
    padding: 0 24px;
    padding-bottom: 32px;

    ${responsive.MOBILE`
      padding: 0 8px;
      margin-bottom: 16px;
    `}

    .ellipse {
      max-width: 520px;
    }

    .participant-info {
      justify-content: space-between;
      column-gap: 16px;
      display: flex;
      flex-wrap: wrap;
      row-gap: 16px;
      .participant-client-info {
        margin-top: 8px;
      }
      .participant-next-session {
        white-space: nowrap;
        display: flex;
        flex-direction: column;
      }
    }
    .MuiTypography-h3 {
      color: ${COLORS.cirrus_black};
    }
    .participant-divider {
      border: 1px solid ${COLORS.cirrus_black_dark};
      opacity: 0.1;
      margin: 24px 0px;

      ${responsive.MOBILE`
        margin: 16px 0;
      `}
    }
    .cards-container {
      ${responsive.MOBILE`
        display: flex;
        gap: 16px;
      `}
    }
  }
  .MuiGrid2-root {
    padding: 0;
  }

  .MuiChip-root {
    background: ${COLORS.cirrus_black1};

    .MuiChip-icon {
      width: 17px;
      height: 17px;
    }

    .MuiChip-label {
      ${textFieldTypographyH5SemiBold}
    }
  }
`;
export const ManageParticipantsInfoCardStyle = styled.div`
  .participant-info-card-activities {
    background-image: url(${ActivitiesLeftBg}), url(${ActivitiesRightBg});
    border: 1px solid ${COLORS.cirrus_peach_light};
  }
  .participant-info-card-events {
    background-image: url(${EventsLeftBg}), url(${EventsRightBg});
    border: 1px solid ${COLORS.cirrus_rose_tint};
  }
  .participant-info-card-assessments {
    background-image: url(${AssessmentLeftBg}), url(${AssessmentRightBg});
    border: 1px solid ${COLORS.cirrus_violet_overlay};
  }
  .participant-info-card-icon-activities {
    background: ${COLORS.cirrus_peach_light};
  }
  .participant-info-card-icon-events {
    background: ${COLORS.cirrus_rose_tint};
  }
  .participant-info-card-icon-assessments {
    background: ${COLORS.cirrus_violet_overlay};
  }

  .participant-info-card {
    box-shadow: 0px 4px 30px 0px ${COLORS.shadow_black_2};
    border-radius: 8px;
    cursor: pointer;

    background-position:
      bottom center,
      bottom -15px right 0px;
    background-repeat: no-repeat, no-repeat;
    background-size: contain, contain;
    height: 120px;
    width: 100%;
    overflow: hidden;
    .participant-info-card-header {
      color: ${COLORS.cirrus_black8};
    }
    padding: 12px;
    .participant-info-card-icon {
      padding: 8px 10px;
      border-radius: 50%;
    }
  }
`;
